<template>
  <add-remittance :prev="prevRoute" />
</template>
<script>
import AddRemittance from '@/components/remittances/AddRemittance'

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.name
    })
  },
  created() {
    const self = this
    window.onbeforeunload = function (e) {
      if (self.$route.path === '/add-remittance') {
        e = e || window.event
        // old browsers
        if (e) {
          e.returnValue = 'Changes you made may not be saved'
        }
        // safari, chrome(chrome ignores text)
        return 'Changes you made may not be saved'
      } else {
        return null
      }
    }
  },
  destroyed() {
    window.onbeforeunload = null
  },
  data() {
    return {
      prevRoute: null
    }
  },
  components: { AddRemittance }
}
</script>
